<div class="login-container">
  <loading *ngIf="isLoading"></loading>
  <h2 class="login-container__title">Create an account</h2>
  <hr class="login-container__divider" />
  <div class="login-container__body">
    <div class="login-container__input">
      <basic-text-input
        #registerFirstName
        [propertyName]="'firstName'"
        [placeholder]="'First Name'"
        [maxlength]="50"
        (valueChanged)="validate()"
      ></basic-text-input>
    </div>

    <div class="login-container__input">
      <basic-text-input
        #registerLastName
        [propertyName]="'lastName'"
        [placeholder]="'Last Name'"
        [maxlength]="50"
        (valueChanged)="validate()"
      ></basic-text-input>
    </div>
    <div class="login-container__input">
      <basic-text-input
        #registerEmail
        [propertyName]="'email'"
        [placeholder]="'Email'"
        (valueChanged)="validate()"
      ></basic-text-input>
    </div>
    <div class="login-container__input">
      <dynamic-validation
        #registerPassword
        [requirementProfile]="'default'"
        [propertyName]="'newPassword'"
        [inputType]="'password'"
        [placeholder]="'Password'"
        (valueChanged)="validate()"
      ></dynamic-validation>
    </div>
    <div class="checkbox">
      <input
        type="checkbox"
        class="checkbox__input"
        id="isVerifiedCheckbox"
        value="isVerifiedValue"
        [(ngModel)]="isVerified"
        (change)="validate()"
      />
      <div class="label-basic">
        <label class="checkbox__label checkbox__label--acknowledge label-basic__text" for="isVerifiedCheckbox">
          <span>
            I agree to the
            <a
              class="button-link login-container__inline-link"
              href="https://www.massmutual.com/privacy-policy"
              target="_blank"
            >
              privacy policy
            </a>
            and
            <a
              class="button-link login-container__inline-link"
              href="https://www.massmutual.com/terms-of-use"
              target="_blank"
            >
              terms of use
            </a>
          </span>
        </label>
      </div>
    </div>
    <div *ngIf="errorMessage" class="login-container__error">{{ errorMessage }}</div>
    <button
      class="button button--yellow button--primary login-container__button"
      role="button"
      (click)="register()"
      [ngClass]="{ 'button--disabled': buttonDisabled }"
    >
      Submit
    </button>
    <div>
      <p class="login-container__link-container">
        <span class="login-container__link login-container__link--underlined" role="button" (click)="goToLogin()">
          Already have an account?
        </span>
      </p>
    </div>
  </div>
</div>
